"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Target = _interopRequireDefault(require("./events/Target.js"));

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _util = require("./util.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/ImageBase
 */


/**
 * @abstract
 */
var ImageBase =
/** @class */
function (_super) {
  __extends(ImageBase, _super);
  /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|undefined} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default} state State.
   */


  function ImageBase(extent, resolution, pixelRatio, state) {
    var _this = _super.call(this) || this;
    /**
     * @protected
     * @type {import("./extent.js").Extent}
     */


    _this.extent = extent;
    /**
     * @private
     * @type {number}
     */

    _this.pixelRatio_ = pixelRatio;
    /**
     * @protected
     * @type {number|undefined}
     */

    _this.resolution = resolution;
    /**
     * @protected
     * @type {import("./ImageState.js").default}
     */

    _this.state = state;
    return _this;
  }
  /**
   * @protected
   */


  ImageBase.prototype.changed = function () {
    this.dispatchEvent(_EventType["default"].CHANGE);
  };
  /**
   * @return {import("./extent.js").Extent} Extent.
   */


  ImageBase.prototype.getExtent = function () {
    return this.extent;
  };
  /**
   * @abstract
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   */


  ImageBase.prototype.getImage = function () {
    return (0, _util["abstract"])();
  };
  /**
   * @return {number} PixelRatio.
   */


  ImageBase.prototype.getPixelRatio = function () {
    return this.pixelRatio_;
  };
  /**
   * @return {number} Resolution.
   */


  ImageBase.prototype.getResolution = function () {
    return (
      /** @type {number} */
      this.resolution
    );
  };
  /**
   * @return {import("./ImageState.js").default} State.
   */


  ImageBase.prototype.getState = function () {
    return this.state;
  };
  /**
   * Load not yet loaded URI.
   * @abstract
   */


  ImageBase.prototype.load = function () {
    (0, _util["abstract"])();
  };

  return ImageBase;
}(_Target["default"]);

var _default = ImageBase;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBTEE7Ozs7O0FBT0E7OztBQUdBO0FBQUE7QUFBQTtFQUF3QkE7RUFDdEI7Ozs7Ozs7O0VBTUEsbUJBQVlDLE1BQVosRUFBb0JDLFVBQXBCLEVBQWdDQyxVQUFoQyxFQUE0Q0MsS0FBNUMsRUFBaUQ7SUFBakQsWUFDRUMscUJBQU8sSUFEVDtJQUdFOzs7Ozs7SUFJQUMsS0FBSSxDQUFDTCxNQUFMLEdBQWNBLE1BQWQ7SUFFQTs7Ozs7SUFJQUssS0FBSSxDQUFDQyxXQUFMLEdBQW1CSixVQUFuQjtJQUVBOzs7OztJQUlBRyxLQUFJLENBQUNKLFVBQUwsR0FBa0JBLFVBQWxCO0lBRUE7Ozs7O0lBSUFJLEtBQUksQ0FBQ0YsS0FBTCxHQUFhQSxLQUFiOztFQUNEO0VBRUQ7Ozs7O0VBR0FJO0lBQ0UsS0FBS0MsYUFBTCxDQUFtQkMsc0JBQVVDLE1BQTdCO0VBQ0QsQ0FGRDtFQUlBOzs7OztFQUdBSDtJQUNFLE9BQU8sS0FBS1AsTUFBWjtFQUNELENBRkQ7RUFJQTs7Ozs7O0VBSUFPO0lBQ0UsT0FBTyx3QkFBUDtFQUNELENBRkQ7RUFJQTs7Ozs7RUFHQUE7SUFDRSxPQUFPLEtBQUtELFdBQVo7RUFDRCxDQUZEO0VBSUE7Ozs7O0VBR0FDO0lBQ0U7TUFBTztNQUF1QixLQUFLTjtJQUFuQztFQUNELENBRkQ7RUFJQTs7Ozs7RUFHQU07SUFDRSxPQUFPLEtBQUtKLEtBQVo7RUFDRCxDQUZEO0VBSUE7Ozs7OztFQUlBSTtJQUNFO0VBQ0QsQ0FGRDs7RUFHRjtBQUFDLENBckZELENBQXdCSSxrQkFBeEI7O2VBdUZlSixTIiwibmFtZXMiOlsiX19leHRlbmRzIiwiZXh0ZW50IiwicmVzb2x1dGlvbiIsInBpeGVsUmF0aW8iLCJzdGF0ZSIsIl9zdXBlciIsIl90aGlzIiwicGl4ZWxSYXRpb18iLCJJbWFnZUJhc2UiLCJkaXNwYXRjaEV2ZW50IiwiRXZlbnRUeXBlIiwiQ0hBTkdFIiwiRXZlbnRUYXJnZXQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3JjL0ltYWdlQmFzZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==